import { type ReactNode } from 'react';

import { Flex, ProgressCircle, Text } from '@spotify-internal/encore-web';

export const DataTableLoadingMore = ({
  children = 'Loading more…',
}: {
  children?: ReactNode;
}): JSX.Element => (
  <Flex
    role="status"
    alignItems="center"
    justifyContent="center"
    gap="tighter"
    padding="base"
  >
    <ProgressCircle size="small" aria-hidden />
    <Text variant="bodySmall" semanticColor="textSubdued">
      {children}
    </Text>
  </Flex>
);
